import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import { ProductOrder } from "../../data/entities";
import { formatNumber } from "../../utils/format";

type ReserveProgress = NonNullable<
    ProductOrder["reserve_import_progress"]
>;

const ReserveImportProgress = ({
    progress,
}: {
    progress?: ReserveProgress | null;
}) => {
    const products = progress?.products ?? [];
    if (products.length === 0) return null;

    return (
        <Box
            sx={{
                border: "1px solid #E5EAF1",
                borderRadius: "8px",
                backgroundColor: "#FFFFFF",
                p: "16px 20px",
                mb: "16px",
                fontFamily: "Noto Sans",
            }}
        >
            <Typography
                sx={{
                    color: "#333739",
                    fontFamily: "Noto Sans",
                    fontSize: "16px",
                    fontWeight: 700,
                    mb: "12px",
                }}
            >
                Tiến độ nhập kho dự phòng
            </Typography>
            <Stack spacing={1.5}>
                {products.map((item) => {
                    const required = Number(item.required_qty || 0);
                    const imported = Number(item.imported_qty || 0);
                    const percentage =
                        required > 0
                            ? Math.min((imported / required) * 100, 100)
                            : 0;
                    return (
                        <Box key={item.product_id}>
                            <Typography
                                sx={{
                                    fontFamily: "Noto Sans",
                                    fontSize: "13px",
                                    fontWeight: 700,
                                    color: "#333739",
                                    mb: "4px",
                                }}
                            >
                                {item.product_name}
                                {item.product_code
                                    ? ` (${item.product_code})`
                                    : ""}
                            </Typography>
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                sx={{ mb: "5px" }}
                            >
                                <Typography
                                    sx={{
                                        fontFamily: "Noto Sans",
                                        fontSize: "13px",
                                        color: "#526171",
                                    }}
                                >
                                    {formatNumber(imported)} /{" "}
                                    {formatNumber(required)} đã nhập
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: "Noto Sans",
                                        fontSize: "13px",
                                        fontWeight: 700,
                                        color:
                                            Number(item.remaining_qty || 0) === 0
                                                ? "#137A4A"
                                                : "#B45309",
                                    }}
                                >
                                    Còn {formatNumber(item.remaining_qty || 0)}
                                </Typography>
                            </Stack>
                            <LinearProgress
                                variant="determinate"
                                value={percentage}
                                sx={{
                                    height: 7,
                                    borderRadius: "4px",
                                    backgroundColor: "#E5EAF1",
                                    "& .MuiLinearProgress-bar": {
                                        backgroundColor:
                                            percentage >= 100
                                                ? "#16845B"
                                                : "#E28A14",
                                    },
                                }}
                            />
                        </Box>
                    );
                })}
            </Stack>
        </Box>
    );
};

export default ReserveImportProgress;
